import { StepType, SurveyState, SurveyStep } from "./survey-models";
import { SurveyUtils } from "./survey-utils";
import { HASH_SEPARATOR, ZIP_CODE_FOUND } from "./survey.constants";

//file contente le funzioni da utilizzare come handler per i click su risposte, breadcrumb etc...

export const AnswerClicked = (child: SurveyStep, state: SurveyState) => {
  console.log(
    `%cClicked ${child.type} - ${child.name}...`,
    "color: indigo; background-color: deeppink; padding: 2px; border-radius: 3px;"
  );
  //caso standard, ha il question, carico lo step successivo con le risposte
  if (child.question) {
    window.location.hash = [
      ...state.paths.map((res) => encodeURIComponent(res.name)),
      encodeURIComponent(child.name),
    ].join(HASH_SEPARATOR);
    SurveyUtils.addZipCodeQueryString(state.insertedCap);
  } else {
    if (child.type === StepType.SUPPORT) { //redirect al supporto
      SurveyUtils.flattenSurveyData(state.paths).then((data) => {
        SurveyUtils.doSupportRedirect(data, null, php_pars.idtripletta?.support);
      });
    } else if (child.url) { // navigazione ad url specifico (mantendendo eventuale CAP)
      window.location.href = child.url + (state.insertedCap ? `?cap=${state.insertedCap}` : '');
    } else if (!child.question && child.name && child.children) {
      //casistica borderline, quando non ha question settato ma ha i children e un name
      child.question = child.name; //uso il name al posto della domanda e tratto lo step come tale
      window.location.hash = [
        ...state.paths.map((res) => encodeURIComponent(res.name)),
        encodeURIComponent(child.name)
      ].join(HASH_SEPARATOR);
      SurveyUtils.addZipCodeQueryString(state.insertedCap);
    }
  }
};
